import { formatStringAsNumber, limitNumTo2AfterDot } from '../../utils/main'

const getPhoneNumbersSumFunc = (state) => {
    const { DIDsAdded } = state.DIDsReducer;
    var total = 0;
    
    DIDsAdded.forEach(item => {
        total += item[411] ? 5.98 : 0;
        total += item.E911 ? 5.99 : 0;
        total += item.CName ? 2.99 : 0;
        total += item.price ? item.price : 0.99;
    });
    
    return {
        count: DIDsAdded.length,
        price: formatStringAsNumber(limitNumTo2AfterDot(total))
    }
}
const getHostedPbxSumFunc = (state) => {
    const { HostedPbxPlan } = state.HostedPbxReducer;
    const { AddOnFeatures } = state.DialingPlansReducer;
    var total = 0;
    
    AddOnFeatures.forEach(item => {
        total += item.price;
    })
    
    total += HostedPbxPlan.price;
    return formatStringAsNumber(limitNumTo2AfterDot(total));
}
const getDialingPlansSumFunc = (state) => {
    const { DialingPlan } = state.DialingPlansReducer;
    var total = 0;
    
    total += DialingPlan.isUnlimited ? 
        (DialingPlan.quantity ? 
            (DialingPlan.quantity * (Number(DialingPlan.quantity) >= 5 ? 19.99 : 24.99))
            :
            0
        )
        :
        (DialingPlan.price);
    return formatStringAsNumber(limitNumTo2AfterDot(total));
}
const getSmsSumFunc = (state) => {
    const { PlansReducer, DIDsReducer } = state;
    const { DIDsAdded, bulkPackagesSelected } = DIDsReducer;
    var total = 0;
    var didSelectBulkSMS = false;

    Object.keys(bulkPackagesSelected).forEach(key => {
        const item = bulkPackagesSelected[key];
        const packagePrice = Number(PlansReducer.bulkPackages.find(el => el.id == key).price.replace(/,/g, ''));
        if(item && item > 0) {
            total += item * packagePrice;
            didSelectBulkSMS = true;
        }
    });
    DIDsAdded.forEach(item => {
        total += item.isUnlimited && !didSelectBulkSMS ? 4.99 : 0;
    });

    return formatStringAsNumber(limitNumTo2AfterDot(total));
}
const getEquipmentSumFunc = (state) => {
    const { EquipmentReducer } = state;
    const { EquipmentSelected, EquipmentInfo } = EquipmentReducer;
    var total = 0;

    Object.keys(EquipmentSelected).map(key => {
        const count = EquipmentSelected[key];
        if(count > 0) {
            Object.keys(EquipmentInfo).find(subKey => {
                const item = EquipmentInfo[subKey].find(el => el.id == key);
                if(item) {
                    total += item.price * count;
                    return true;
                }
            });
        }
    })
    return formatStringAsNumber(limitNumTo2AfterDot(total));
}
const getEquipmentCountFunc = (state) => {
    const { EquipmentReducer } = state;
    const { EquipmentSelected } = EquipmentReducer;
    var totalCount = 0;

    Object.keys(EquipmentSelected).map(key => {
        const count = EquipmentSelected[key];
        if(count > 0) {
            totalCount += count;
        }
    })
    return formatStringAsNumber(totalCount);
}

export const getPhoneNumbersSum = () => {
    return (dispatch, getState) => {
        return getPhoneNumbersSumFunc(getState());
    }
}
export const getHostedPbxSum = () => {
    return (dispatch, getState) => {
        return getHostedPbxSumFunc(getState());
    }
}
export const getDialingPlansSum = () => {
    return (dispatch, getState) => {
        return getDialingPlansSumFunc(getState());
    }
}
export const getSmsSum = () => {
    return (dispatch, getState) => {
        return getSmsSumFunc(getState());
    }
}
export const getEquipmentSum = () => {
    return (dispatch, getState) => {
        return getEquipmentSumFunc(getState());
    }
}
export const getEquipmentCount = () => {
    return (dispatch, getState) => {
        return getEquipmentCountFunc(getState());
    }
}
export const getAllItemsSummary = () => {
    return (dispatch, getState) => {
        const state = getState();
        const items = [
            getPhoneNumbersSumFunc(state).price,
            getHostedPbxSumFunc(state),
            getDialingPlansSumFunc(state),
            getSmsSumFunc(state),
            getEquipmentSumFunc(state),
        ];
        var total = 0;
        items.forEach(item => {
            total += Number(item.toString().replace(/,/g,''));
        })
        return formatStringAsNumber(limitNumTo2AfterDot(total));
    }
}
